<div class="modal-container tile-container">
    <div class="modal-header">
        <h2 class="modal-title">Edit Vaccine</h2>
        <button class="close-btn" (click)="onClose()" type="button">
            &times;
        </button>
    </div>

    <div class="modal-body scrollbar-custom">
        <form
            [formGroup]="vaccineForm"
            (ngSubmit)="onSubmit()"
            class="add-vaccine-form"
        >
            <!-- Row 1: Brand and Supplier -->
            <div class="form-row mb-3">
                <div class="form-group">
                    <label for="brand"
                        >Brand
                        <span class="text-danger-required">*</span></label
                    >
                    <input
                        type="text"
                        id="brand"
                        formControlName="brand"
                        class="form-control"
                        placeholder="Please enter brand name"
                    />
                    <div
                        *ngIf="
                            vaccineForm.get('brand').invalid &&
                            vaccineForm.get('brand').touched
                        "
                        class="text-danger"
                    >
                        Please select brand name.
                    </div>
                </div>

                <div class="form-group">
                    <label for="arabicBrand">
                              Arabic Brand Name
                    </label>

                   <input
                        id="arabicBrand"
                        formControlName="arabicBrandName"
                        type="text"
                        class="form-control"
                        placeholder="Enter Arabic brand name"
                        dir="rtl"
                    />
                    <div
                        *ngIf="
                            vaccineForm.get('arabicBrandName')?.invalid &&
                            vaccineForm.get('arabicBrandName')?.touched
                        "
                        class="text-danger"
                    >
                        Only Arabic characters are allowed.
                    </div>
                </div>

                <div class="form-group">
                    <label for="supplier"
                        >Supplier
                        <span class="text-danger-required">*</span></label
                    >
                    <select
                        id="supplier"
                        formControlName="supplierTypeId"
                        class="form-control"
                    >
                        <option value="" disabled selected>
                            Please choose the source
                        </option>
                        <option
                            *ngFor="let supplier of suppliers"
                            [value]="supplier.id"
                        >
                            {{ supplier.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            vaccineForm.get('supplierTypeId').invalid &&
                            vaccineForm.get('supplierTypeId').touched
                        "
                        class="text-danger"
                    >
                        Please select supplier.
                    </div>
                </div>
            </div>

            <!-- Row 2: Expiry Date and Batch Number -->
            <div class="form-row mb-3">
                <div class="form-group">
                    <label for="expireDate"
                        >Expiry Date
                        <span class="text-danger-required">*</span></label
                    >
                    <input
                        type="date"
                        id="expireDate"
                        formControlName="expireDate"
                        class="form-control"
                        placeholder="Expire date"
                        (click)="triggerDatePicker($event)"
                    />
                    <div
                        *ngIf="
                            vaccineForm.controls['expireDate'].errors?.[
                                'futureDate'
                            ]
                        "
                        class="text-danger"
                    >
                        The date must be today or in the future.
                    </div>
                    <div
                        *ngIf="
                            vaccineForm.get('expireDate').invalid &&
                            vaccineForm.get('expireDate').touched
                        "
                        class="text-danger"
                    >
                        Please select date.
                    </div>
                </div>

                <div class="form-group">
                    <label for="batchNumber"
                        >Batch Number
                        <span class="text-danger-required">*</span></label
                    >
                    <input
                        type="text"
                        id="batchNumber"
                        formControlName="batchNumber"
                        class="form-control"
                        placeholder="Enter batch number"
                    />
                    <div
                        *ngIf="
                            vaccineForm.get('batchNumber').invalid &&
                            vaccineForm.get('batchNumber').touched
                        "
                        class="text-danger"
                    >
                        Please select batch.
                    </div>
                </div>
            </div>

            <!-- Row 3: Classification and Application Type -->
            <div class="form-row mb-3">
                <div class="form-group">
                    <label for="type"
                        >Classification
                        <span class="text-danger-required">*</span></label
                    >
                    <select
                        id="type"
                        formControlName="vaccineTypeId"
                        class="form-control"
                    >
                        <option value="" disabled selected>
                            Please choose the type
                        </option>
                        <option
                            *ngFor="let classification of classifications"
                            [value]="classification.id"
                        >
                            {{ classification.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            vaccineForm.get('vaccineTypeId').invalid &&
                            vaccineForm.get('vaccineTypeId').touched
                        "
                        class="text-danger"
                    >
                        Please select type.
                    </div>
                </div>

                <div class="form-group">
                    <label for="applicationId"
                        >Application Type
                        <span class="text-danger-required">*</span></label
                    >
                    <select
                        id="applicationId"
                        formControlName="applicationId"
                        class="form-control"
                    >
                        <option value="" disabled selected>
                            Please choose the application
                        </option>
                        <option
                            *ngFor="let type of applications"
                            [value]="type.id"
                        >
                            {{ type.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            vaccineForm.get('applicationId').invalid &&
                            vaccineForm.get('applicationId').touched
                        "
                        class="text-danger"
                    >
                        Please select application.
                    </div>
                </div>
            </div>

            <!-- Row 4: SKU and Quantity -->
            <div class="form-row mb-3">
                <div class="form-group">
                    <label for="sku">SKU</label>
                    <input
                        type="text"
                        id="sku"
                        formControlName="sku"
                        class="form-control"
                        placeholder="Please enter sku"
                    />
                </div>
                <div class="form-group">
                    <label for="quantity"
                        >Quantity
                        <span class="text-danger-required">*</span></label
                    >
                    <input
                        id="quantity"
                        formControlName="qty"
                        type="number"
                        class="form-control"
                        placeholder="Enter quantity"
                    />
                    <div
                        *ngIf="
                            vaccineForm.get('qty').invalid &&
                            vaccineForm.get('qty').touched
                        "
                        class="text-danger"
                    >
                        Please select quantity.
                    </div>
                    <span
                        class="text-danger"
                        *ngIf="vaccineForm.get('qty').errors?.min"
                        >Value must be non-negative.</span
                    >
                </div>
            </div>

            <!-- Row 5: Hatchery and Farm -->
            <div class="form-row mb-3">
                <div class="form-group">
                    <label for="hatchery"
                        >Hatchery
                        <span class="text-danger-required">*</span></label
                    >
                    <select
                        id="hatchery"
                        formControlName="hatcheryTypeId"
                        class="form-control"
                    >
                        <option value="" disabled selected>
                            Please choose the hatchery
                        </option>
                        <option
                            *ngFor="let hatchery of hatcheryVaccination"
                            [value]="hatchery.id"
                        >
                            {{ hatchery.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            vaccineForm.get('hatcheryTypeId').invalid &&
                            vaccineForm.get('hatcheryTypeId').touched
                        "
                        class="text-danger"
                    >
                        Please select hatchery.
                    </div>
                </div>
                <div class="form-group">
                    <label for="farm"
                        >Farm <span class="text-danger-required">*</span></label
                    >
                    <select
                        id="farmid"
                        formControlName="farmId"
                        class="form-control"
                    >
                        <option value="" disabled selected>
                            Please choose the farm
                        </option>
                        <option *ngFor="let item of farmlist" [value]="item.id">
                            {{ item.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            vaccineForm.get('farmId').invalid &&
                            vaccineForm.get('farmId').touched
                        "
                        class="text-danger"
                    >
                        Please select farm.
                    </div>
                </div>
            </div>

            <!-- Row 7: Chick Age From/To and Low Level Stock -->
            <div class="form-row mb-3 three-cols">
                <div class="form-group">
                    <label for="chickAgeFrom"
                        >Chick Age (From) (days)
                        <span class="text-danger-required">*</span></label
                    >
                    <input
                        id="chickAgeFrom"
                        formControlName="chickAgeFrom"
                        type="number"
                        class="form-control"
                        placeholder="Enter chick age from"
                    />
                    <div
                        *ngIf="
                            vaccineForm.get('chickAgeFrom').invalid &&
                            vaccineForm.get('chickAgeFrom').touched
                        "
                        class="text-danger"
                    >
                        Please select age.
                    </div>
                    <span
                        class="text-danger"
                        *ngIf="vaccineForm.get('chickAgeFrom').errors?.min"
                        >Value must be non-negative.</span
                    >
                </div>

                <div class="form-group">
                    <label for="chickAgeTo"
                        >Chick Age (To) (days)
                        <span class="text-danger-required">*</span></label
                    >
                    <input
                        id="chickAgeTo"
                        formControlName="chickAgeTo"
                        type="number"
                        class="form-control"
                        placeholder="Enter chick age to"
                    />
                    <div
                        *ngIf="
                            vaccineForm.get('chickAgeTo').invalid &&
                            vaccineForm.get('chickAgeTo').touched
                        "
                        class="text-danger"
                    >
                        Please select age.
                    </div>
                    <span
                        class="text-danger"
                        *ngIf="vaccineForm.get('chickAgeTo').errors?.min"
                        >Value must be non-negative.</span
                    >
                    <div
                        class="text-danger"
                        *ngIf="
                            vaccineForm.get('chickAgeFrom').valid &&
                            vaccineForm.get('chickAgeTo').dirty &&
                            vaccineForm.get('chickAgeFrom').value >
                                vaccineForm.get('chickAgeTo').value
                        "
                    >
                        Age to must be greater than age from.
                    </div>
                </div>

                <div class="form-group">
                    <label for="lowStockLevel"
                        >Low Level Stock
                        <span class="text-danger-required">*</span></label
                    >
                    <input
                        type="text"
                        id="lowStockLevel"
                        formControlName="lowStockLevel"
                        class="form-control"
                        placeholder="Enter low level stock"
                    />
                    <div
                        *ngIf="
                            vaccineForm.get('lowStockLevel').invalid &&
                            vaccineForm.get('lowStockLevel').touched
                        "
                        class="text-danger"
                    >
                        Please select low level stock.
                    </div>
                </div>
            </div>

            <!-- Submit Button -->
            <div class="form-actions">
                <button
                    class="btn close-btn-secondary"
                    type="button"
                    (click)="onClose()"
                >
                    Close
                </button>
                <button
                    class="btn btn-action-primary"
                    type="submit"
                    [disabled]="isLoading$ | async"
                >
                    <span class="submit-button-text" *ngIf="!isAuthLoading"
                        >Update Vaccine Record</span
                    >
                    <span class="submit-button-text" *ngIf="isAuthLoading"
                        >Updating...</span
                    >
                </button>
                <img
                    *ngIf="isLoading$ | async"
                    src="assets/img/loader.gif"
                    alt="Loading..."
                    class="loader-image mt-2"
                />
            </div>
        </form>
    </div>
</div>
